import React, {useEffect, memo} from "react";
import PropTypes from "prop-types";

//components:
import {makeStyles} from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: "1rem",
        width: "100%",
        "& > * + *": {
            marginTop: theme.spacing(3),
        },
    },
}));

export const MultipleSelect = memo(
    ({setSelectedOptions, selectedOptions, options, label}) => {
        const classes = useStyles();
        const defaultSelectedSerie = [{data: []}];
        const handleChange = values => setSelectedOptions(values);

        useEffect(() => {
            const seriesByDefault = options?.[0] ? [options[0]] : defaultSelectedSerie;
            setSelectedOptions(seriesByDefault);
        }, [options, setSelectedOptions]);

        return (
            <div className={classes.root}>
                <Autocomplete
                    multiple
                    filterSelectedOptions
                    options={options || []}
                    // defaultValue={options?.[0] || {}}
                    value={selectedOptions || {}}
                    getOptionLabel={option => option?.name}
                    onChange={(e, value, reason) => {
                        if (reason === "select-option" || (reason === "remove-option" && value.length)) {
                            return handleChange(value);
                        }
                    }}
                    renderInput={params => <TextField {...params} variant="outlined" label="" placeholder={label} />}
                    closeIcon={
                        <span
                            className="d-flex p-2"
                            onClick={() => setSelectedOptions(options?.[0] ? [options[0]] : defaultSelectedSerie)}
                        >
                            <CloseIcon style={{fontSize: "15px"}} />
                        </span>
                    }
                />
            </div>
        );
    },
    (prevState, nextState) =>
        prevState.setSelectedOptions === nextState.setSelectedOptions &&
        prevState.selectedOptions === nextState.selectedOptions &&
        prevState.options === nextState.options &&
        prevState.label === nextState.label
);

MultipleSelect.propTypes = {
    setSelectedOptions: PropTypes.func,
    selectedOptions: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            data: PropTypes.arrayOf(PropTypes.number),
        })
    ),
    options: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            data: PropTypes.arrayOf(PropTypes.number),
        })
    ),
    label: PropTypes.string,
};
